import { MorphemeMnemonicsView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics";

/**
 * A grapheme's mnemonics (the meaning tab plus one tab per prevalent reading) as a standalone
 * card surface, under `MorphemePanelsFlashcardProviders`. `initialPinyin` opens on that reading — a
 * pronunciation drill lands on the reading it asked for.
 */
export function GraphemeMnemonicsFlashcardSurface({
  initialPinyin,
  rawGrapheme,
}: {
  initialPinyin?: string;
  rawGrapheme: string;
}) {
  return <MorphemeMnemonicsView initialPinyin={initialPinyin} rawGrapheme={rawGrapheme} />;
}
